import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;

// Public site/support info from Admin Settings (WhatsApp, email, hours, social, site URL).
export const useSiteInfo = () => {
  const [info, setInfo] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/public/site-info").then((r) => { cache = r.data; setInfo(r.data); }).catch(() => {});
  }, []);
  return info || {};
};

const ATTR_KEY = "avb_attr";
const SESSION_KEY = "avb_session";
const uuid = () => "s-" + Math.random().toString(36).slice(2) + Date.now().toString(36);

export const getSessionId = () => {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) { id = uuid(); localStorage.setItem(SESSION_KEY, id); }
  return id;
};

export const getAttribution = () => {
  try { return JSON.parse(localStorage.getItem(ATTR_KEY) || "{}"); } catch { return {}; }
};

// Capture UTM / referrer attribution. First-touch is set once, last-touch refreshes on new UTMs.
export const captureAttribution = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {
      source: params.get("utm_source") || "", medium: params.get("utm_medium") || "",
      campaign: params.get("utm_campaign") || "", term: params.get("utm_term") || "",
      content: params.get("utm_content") || "",
    };
    const hasUtm = utm.source || utm.medium || utm.campaign;
    const now = new Date().toISOString();
    const stored = getAttribution();
    if (!hasUtm && !stored.source) {
      const ref = document.referrer || "";
      if (/google\./i.test(ref)) { utm.source = "google"; utm.medium = "organic"; }
      else if (/instagram\./i.test(ref)) { utm.source = "instagram"; utm.medium = "social"; }
      else if (/facebook\.|fb\./i.test(ref)) { utm.source = "facebook"; utm.medium = "social"; }
      else if (/wa\.me|whatsapp/i.test(ref)) { utm.source = "whatsapp"; utm.medium = "message"; }
      else if (ref) { utm.source = "referral"; utm.medium = "referral"; }
      else { utm.source = "direct"; utm.medium = "none"; }
    }
    const next = { ...stored };
    if (!stored.first_at && (hasUtm || utm.source)) {
      next.first_source = utm.source; next.first_medium = utm.medium;
      next.first_campaign = utm.campaign; next.first_landing_page = window.location.pathname; next.first_at = now;
    }
    if (hasUtm || !stored.source) {
      next.source = utm.source; next.medium = utm.medium; next.campaign = utm.campaign;
      next.term = utm.term; next.content = utm.content;
      next.landing_page = window.location.pathname; next.referrer = document.referrer || ""; next.last_at = now;
    }
    localStorage.setItem(ATTR_KEY, JSON.stringify(next));
    return next;
  } catch { return {}; }
};

// Fire-and-forget analytics event enriched with session + campaign attribution.
export const track = (event, meta) => {
  try {
    if (localStorage.getItem("avb_consent") === "declined") return;
    const attr = getAttribution();
    api.post("/analytics/event", {
      event,
      meta: { ...(meta || {}), session_id: getSessionId(), campaign: attr.campaign || "", source: attr.source || "" },
    }).catch(() => {});
  } catch { /* no-op */ }
};

export const waLink = (number, text) => {
  const n = String(number || "").replace(/[^0-9]/g, "");
  if (!n) return "#";
  return `https://wa.me/${n}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};
